module.exports = __webpack_public_path__ + "img/icon_vip_mangguo@2x.f407572a.png";